import React from 'react';
import PropTypes from 'prop-types';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Slider from '@material-ui/core/Slider';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Tooltip from '@material-ui/core/Tooltip';

const useStyles = makeStyles((theme) => ({

  margin: {
    height: theme.spacing(0),
  },
}));

function ValueLabelComponent(props) {
  const { children, open, value} = props;

  return (
    <Tooltip open={open} enterTouchDelay={0} placement="top" arrow title={`${100-value}% / ${value}%`}>
      {children}
    </Tooltip>
  );
}

const PrettoSlider = withStyles({
  root: {
    color: '#52afff',
    height: 8,
  },
  thumb: {
    height: 24,
    width: 24,
    backgroundColor: '#fff',
    border: '2px solid currentColor',
    marginTop: -8,
    marginLeft: -12,
    '&:focus, &:hover, &$active': {
      boxShadow: 'inherit',
    },
  },
  active: {},
  valueLabel: {
    left: 'calc(-50% + 4px)',
  },
  track: {
    height: 8,
    borderRadius: 4,
  },
  rail: {
    height: 8,
    borderRadius: 4,
  },
})(Slider);

export default function CustomizedSlider(props) {
  const classes = useStyles();


  const handleChange = (event, newValue, props) => {
    const newWords = props.words;
    newWords[props.id][0].value = 100-newValue;
    newWords[props.id][1].value = newValue;
    props.setValue(newWords);
  };
  console.log(props.id);
  return (
  <div className={classes.root}>
    <div className={classes.margin} />
      <Grid container spacing={3}>
        <Grid item xs={4}>
           <div style={{float:"right", paddingTop: 6}}>{props.left.name}</div>
        </Grid>
        <Grid item xs={4}>
          <PrettoSlider 
            valueLabelDisplay="auto" 
            aria-label="pretto slider" 
            defaultValue={50} 
            ValueLabelComponent={ValueLabelComponent}
            onChange={(event, newValue)=>handleChange(event, newValue, props)} />
        </Grid>
        <Grid item xs={4}>
        <div style={{float:"left", paddingTop: 6}}>{props.right.name}</div>
        </Grid>
      </Grid>
  </div>
  );
}
